import api from "../utils/API";

const getScoredCandidates = (missionUuid, forceRefresh = false) => {
  return api.get(`/mission/${missionUuid}/scoring`, {
    params: { force_refresh: forceRefresh },
  });
};

const runAgentScoring = (missionUuid) => {
  return api.post(`/mission/${missionUuid}/scoring/run-agent`);
};

const exportCsv = (missionUuid) => {
  return api.get(`/mission/${missionUuid}/scoring/export/csv`, {
    responseType: "blob",
  });
};

const exportPdf = (missionUuid) => {
  return api.get(`/mission/${missionUuid}/scoring/export/pdf`, {
    responseType: "blob",
  });
};

export { getScoredCandidates, runAgentScoring, exportCsv, exportPdf };
